module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (8).5e9cd845.jpg";